import type { ReactNode } from "react";
import type { Route } from "next";
import Link from "next/link";

interface Props<R extends string> {
  href: Route<R> | undefined;
  className?: string;
  children: ReactNode;
  link: boolean;
}

export default function LinkOrDiv<R extends string>({ href, className, link, children }: Props<R>) {
  if (link && href) {
    return (
      <Link className={className} href={href}>
        {children}
      </Link>
    );
  }

  return <div className={className}>{children}</div>;
}
